// extracted by mini-css-extract-plugin
module.exports = {"container":"MaxWidth_container__mpQrp","xs":"MaxWidth_xs__n9lUh","sm":"MaxWidth_sm__0EHjj","md":"MaxWidth_md__N0aCv","lg":"MaxWidth_lg__SBCEP"};